<template>
  <footer class="footer" style="float: right">
    <nav style="margin-left: auto;">
      <ul>
        <li>
          <a href="#/tnc" target="_blank">{{ $t("Terms of Use") }}</a>
        </li>
        <li>
          <a href="#/privacy" target="_blank">{{ $t("Privacy") }}</a>
        </li>
        <li>
          <a
            href="https://laws-lois.justice.gc.ca/eng/regulations/SOR-96-433/FullText.html"
            target="_blank"
            >{{ $t("Canadian Aviation Regulations") }}</a
          >
        </li>
      </ul>
    </nav>

    <div class="copyright text-center">
      &copy; {{ new Date().getFullYear() }}
      <a href="https://aimrobotics.io">AIM Robotics</a>
      &nbsp;v2.4.1&nbsp;
    </div>
  </footer>
</template>
<script>
export default {};
</script>
